<template>
  <div class="pay-container">
    <van-nav-bar :title="$route.meta.title">
      <template #left>
        <van-icon @click="back" name="arrow-left" color="#46474B" size="20px" />
      </template>
    </van-nav-bar>
   <div class="pay-success text-align-center">
      <img src="@/assets/pay-state/pay-error.png" alt="">
     <p class="status" :class="norefund && 'status-pd'">
       支付取消
     </p>
     <p class="msg" v-show="!norefund">
       完成支付后可以尽早咨询律师哦
     </p>

     <p v-show="contractTemplateStatus" class="msg">
       订单付款失败，您可以重新付款
     </p>
      <div class="btns flex flex-column">
        <button @click="toPayAgain">
          重新支付
        </button>
        <button @click="handleBtn">
          返回
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/**

 */
import { callApp } from '@/libs/bridge'
import { NavBar, Icon } from 'vant'
import {toPay} from "@/libs/tool.js";
// import { orderPay } from '@/api/falinapi'
// import { newOrderType } from '@/libs/config'
export default {
  components: {
    'van-icon': Icon,
    'van-nav-bar': NavBar
  },
  mounted () {
    window.physicsBackFn = this.back
  },
  computed: {
    // 没有退款的情况
    norefund () {
      return Number(this.$route.query.buyServiceType) === 4 || Number(this.$route.query.buyServiceType) === 5 || Number(this.$route.query.buyServiceType) === 9
    },
    /* 合同模板状态 */
    contractTemplateStatus () {
      return Number(this.$route.query.buyServiceType) === 9
    }
  },
  methods: {
    back () {
      // // 20220923 synWdIdaa之前逻辑
      // callApp('finishActivity')
      //  // synWdId 问题信息 v2.2.8新增 主要用于落地页公共付费咨询带信息入库 需要同步的问答id对应的信息
      const { orderId, buyServiceType, lawyerId, serviceCode, businessId, synHistoryId, synWdId } = { ...this.$route.query }
      this.$router.push(`/confirm-order?orderId=${orderId}&serviceCode=${serviceCode}&type=${buyServiceType}&lawyerId=${lawyerId}&businessId=${businessId}&synHistoryId=${synHistoryId}&synWdId=${synWdId}`)

    },
    toPayAgain () {
      this.toPayWeixin(this.$route.query.orderId)
    },
    async toPayWeixin (orderId) {
      // const hasOrderPayQuery = {
      //   /* 业务订单id */
      //   orderId,
      //   // payType: 2, /* 支付类型[lawsuitShare:支付宝,2:微信]*/
      //   payType: Number(this.$route.query.payType) || 2
      // }
      // const resp = await orderPay(hasOrderPayQuery)
      // window.location.href = JSON.parse(resp.data.payResultMsg).h5_url

      const a = this.$toast.loading('加载中')
      return toPay({
        orderId,
        payType: Number(this.$route.query.payType) || 2,
        redirectPath: '/confirm-order/pay-loading'
      }).then(({ data }) => {
        a.clear()
        return data
      }).catch(() => {
        a.clear()
      })
    },
    handleBtn () {
      // 去订单页面
      callApp('toMineOrderLs')
    }
  }
}
</script>

<style scoped lang="scss">
.pay-container{
  min-height: 100vh;
  background: white;
}
.pay-success{
  font-size: 0;
  .status{
    padding: 29px 0 8px 0;
    font-size: 18px;
    color: #333333;
  }
  .status-pd{
    padding-bottom: 24px;
  }
  .msg{
    color: #333333;
    padding-bottom: 24px;
    font-size: 14px;
  }
  img{
    padding-top: 48px;
    width: 121px;
    height: 120px;
  }
  .btns{
    align-items: center;
    button{
      width: 160px;
      height: 32px;
      border-radius: 20px;
      border: 1px solid #366EFF;
      font-size: 14px;
      background: #366EFF;
      color: #fff;
    }
    button{
      &:nth-child(2){
        background: white;
        margin-top: 15px;
        border-radius: 20px;
        border: 1px solid #EEEEEE;
        color: #333333;
      }
    }
  }
}
</style>
